import { authApi } from '@jq4race/api-client';

import type { AuthRepository } from '../../domain/ports/auth-repository';

export const httpAuthRepository: AuthRepository = {
  login: authApi.login,
  activateInvitation: authApi.activate,
  requestPasswordReset: authApi.requestPasswordReset,
  resetPassword: authApi.resetPassword,
  setupMfa: authApi.setupMfa,
  activateMfa: authApi.activateMfa,
  verifyMfa: authApi.verifyMfa,
  requestMfaEmailOtp: authApi.requestMfaEmailOtp,
  verifyMfaEmailOtp: authApi.verifyMfaEmailOtp,
};
